<template>
  <div class="change-email">
    <div class="title">{{$t(`setting.${params.updateType}`)}}</div>
    <el-tabs v-model="activeName"
             @tab-click="selectVerifyType"
             >
      <el-tab-pane :label="$t('setting.byPhone')"
                   name="phone"
                   :disabled="switchPhone">
        <div class="tip">
          <h4 v-html="phoneTip"></h4>
        </div>
      </el-tab-pane>
      <!-- <el-tab-pane label="邮箱验证"
                   name="email"
                   :disabled="switchEmail">
        <div class="tip">
          <h4 v-html="emailTip"></h4>
        </div>
      </el-tab-pane> -->
    </el-tabs>
    <el-form :model="ruleForm2"
             ref="ruleForm2"
             :rules="rules"
             label-width="0"
             class="demo-ruleForm"
             @submit.native.prevent>
      <!-- 修改手机 -->
      <el-form-item class="new-phone"
                    v-if="params.updateType === 'changePhoneNum' && current === 2"
                    prop="newPhone"
                    :label-width="formLabelWidth">
        <el-input :disabled="isEnter"
                  test_id="input_new_phone"
                  v-model="ruleForm2.newPhone"
                  minlength="11"
                  :placeholder="$t('setting.changePhone.phoneNumPlaceholder')"
                  autocomplete="off">
          <template slot="prepend">+{{params.areaCode}}</template>
        </el-input>
      </el-form-item>
      <!-- 修改邮箱 -->
      <el-form-item label=""
                    v-if="params.updateType==='changeEmailAdd' && current === 2"
                    prop="email">
        <el-input v-model="ruleForm2.email"></el-input>
      </el-form-item>
      <el-form-item label=""
                    prop="code">
        <el-input v-model="ruleForm2.code"
                  placeholder=""
                    maxlength="6">
          <span v-show="sendAuthCode"
                class="btn-code"
                slot="suffix"
                @click="getCode">{{sendCodeTitle}}
          </span>
          <span v-show="!sendAuthCode"
                class="btn-auth-code"
                slot="suffix">{{auth_time}}S
          </span>
        </el-input>
      </el-form-item>
    </el-form>

    <div class="el-button--sub">
      <el-button type="primary"
                 :loading="loadingSubmit"
                 @click="checkSubmitData('ruleForm2')">{{$t('setting.setPassword.submit')}}</el-button>
    </div>
    <div class="el-button--cencel">
      <el-button type="primary"
                 :loading="loadingSubmit"
                 @click="cencel('ruleForm2')">{{$t('changeEmail.cencel')}}</el-button>
    </div>
  </div>
</template>

<script>
import SecurityService from '../../../js/util/SecurityService'
import commonRequest from '@/api/v2/common.js'
import { mapGetters } from 'vuex'

export default {
  props: ['params'],
  data () {
    const checkEmail = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error(this.$t('common.please_input')))
      }
      var reg = /^([a-zA-Z0-9]+[_|\_|\.\-]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/
      if (!reg.test(value)) {
        callback(this.$t('changeEmail.error.3'))
      }
      if (value === this.params.email) {
        return callback(new Error(this.$t('changeEmail.error.2')))
      }
      callback()
    }
    const checkPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t('setting.changePhone.phoneInput')))
      } else if (value === this.params.changePhoneNum) {
        callback(new Error(this.$t('setting.changePhone.samePhone')))
      }
      if (this.params.areaCode === '86') {
        let patrn = /^[1][3,4,5,7,8,9][0-9]{9}$/
        if (!patrn.exec(value)) {
          callback(new Error(this.$t('setting.changePhone.phoneErr')))
        }
      } else if (this.params.areaCode === '852') {
        let patrn = /^[0-9]{8}$/
        if (!patrn.exec(value)) {
          callback(new Error(this.$t('setting.changePhone.phoneErr')))
        }
      }
      callback()
    }
    const checkCode = (rule, value, callback) => {
      let patrn = /^[0-9]{6}$/
      if (!patrn.exec(value)) {
        return callback(new Error(this.$t('setting.changePhone.codeInput')))
      } else {
        callback()
      }
    }
    return {
      isEnter: false,
      formLabelWidth: '0',
      activeName: 'phone',
      loadingSubmit: false,
      phoneTip: '',
      emailTip: '',
      switchPhone: false, // 是否可切换验证方式
      switchEmail: false,
      ruleForm2: {
        newPhone: '',
        email: '',
        code: ''
      },
      sendCodeTitle: this.$t('changeEmail.getCode'),
      sendAuthCode: true,
      auth_time: 0,
      /* 倒计时 计数器 */
      oldSendStatus: false,
      rules: {
        email: [{
          required: true,
          validator: checkEmail,
          trigger: 'change'
        }],
        newPhone: [{
          required: true,
          validator: checkPhone,
          trigger: 'change'
        }],
        code: [{
          required: true,
          validator: checkCode,
          message: this.$t('changeEmail.code'),
          trigger: 'change'
        }]
      },
      deviceId: 'ceshiid',
      auth_timetimer: null,
      oldCodeSuccess: false,
      current: 1

    }
  },
  computed: {
    ...mapGetters([
      'getClientProfile'
    ])
  },
  watch: {
    params (val) {
      if (this.params.updateType === 'changePhoneNum') {
        this.activeName = 'phone'
      } else if (this.params.updateType === 'changeEmailAdd') {
        // this.activeName = 'email'
        this.activeName = 'phone'
      }
    },
    'params.updateType' (newVal, oldVal) {
      console.log(oldVal, newVal)
      if (newVal) {
        this.handTime(oldVal)
      }
    }
  },
  mounted () {
    this.handTip(1)
  },
  methods: {
    handTip (current) {
      if (current === 1) {
        this.phoneTip = this.$t('setting.changePhone.phoneTitle') + ' +' + this.params.changePhoneNumShow
        this.emailTip = this.$t('changeEmail.oldTip', [this.params.email])
      } else if (current === 2 && this.params.updateType === 'changePhoneNum') {
        this.phoneTip = this.$t('setting.changePhone.subtitle')
        this.emailTip = this.$t('setting.changePhone.subtitle')
      } else {
        this.phoneTip = this.$t('changeEmail.newTip')
        this.emailTip = this.$t('changeEmail.newTip')
      }
    },
    handTime (newVal) {
      if (this.auth_timetimer && newVal) {
        console.log(this.auth_timetimer)
        this.clearIntervals()
      }
    },
    // 处理倒计时
    getAuthCode () {
      this.sendAuthCode = false
      this.auth_time = 60
      this.auth_timetimer = setInterval(() => {
        this.auth_time--
        if (this.auth_time <= 0) {
          this.sendAuthCode = true
          this.sendCodeTitle = this.$t('changeEmail.reset')
          clearInterval(this.auth_timetimer)
        }
      }, 1000)
    },
    getEmailService (email) {
      let hash = {
        'qq.com': 'http://mail.qq.com',
        'gmail.com': 'http://mail.google.com',
        'sina.com': 'http://mail.sina.com.cn',
        '163.com': 'http://mail.163.com',
        '126.com': 'http://mail.126.com',
        'yeah.net': 'http://www.yeah.net/',
        'sohu.com': 'http://mail.sohu.com/',
        'tom.com': 'http://mail.tom.com/',
        'sogou.com': 'http://mail.sogou.com/',
        '139.com': 'http://mail.10086.cn/',
        'hotmail.com': 'http://www.hotmail.com',
        'live.com': 'http://login.live.com/',
        'live.cn': 'http://login.live.cn/',
        'live.com.cn': 'http://login.live.com.cn',
        '189.com': 'http://webmail16.189.cn/webmail/',
        'yahoo.com.cn': 'http://mail.cn.yahoo.com/',
        'yahoo.cn': 'http://mail.cn.yahoo.com/',
        'eyou.com': 'http://www.eyou.com/',
        '21cn.com': 'http://mail.21cn.com/',
        '188.com': 'http://www.188.com/',
        'foxmail.coom': 'http://www.foxmail.com'
      }
      let add = email.slice(email.indexOf('@') + 1)
      for (let key in hash) {
        if (key === add) {
          return hash[key]
        }
      }
      return false
    },
    // 发送手机验证码
    sendPhoneCode () {
      let canSend = true
      if (this.current === 2) {
        this.$refs.ruleForm2.validateField('newPhone', isValid => {
          if (isValid) {
            canSend = false
          } else {
            console.log(isValid)
            canSend = true
          }
        })
      }
      if (canSend) {
        this.requestPhoneCode()
      }
    },
    requestPhoneCode () {
      let phoneNumber
      this.current === 1 ? phoneNumber = this.params.changePhoneNum : phoneNumber = this.ruleForm2.newPhone
      // let options = {
      //   areaCode: this.params.areaCode,
      //   source: 'clientPortal',
      //   type: 'setting_pwd'
      // }
       let params = {
        device_id: this.deviceId,
        phone: this.params.areaCode + phoneNumber,
        send_type: 'update_phone'
      }

      this.getAuthCode()
      commonRequest.getVCode(params).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('setting.changePhone.sendSuccess'))
        } else {
            this.$message.error('获取验证码失败')
        }
      })
      // this.countStyle = { 'pointer-events': 'none' }
      // this.$api.getVCode(options, phoneNumber).then(result => {
      //   this.$message.success(this.$t('setting.changePhone.sendSuccess'))
      // }).catch(error => {
      //   let errMessage = ''
      //   if (error.code) {
      //     switch (error.code) {
      //       case '5008':
      //         errMessage = this.$t('setting.5008')
      //         break
      //       default:
      //         errMessage = this.$t('setting.40000')
      //         break
      //     }
      //     return this.$message.error(errMessage)
      //   } else {
      //     errMessage = this.$t('setting.40000')
      //     return this.$message.error(errMessage)
      //   }
      // })
    },
    // 发送邮件验证码
    sendEmailCode () {
      let canSend = true
      if (this.current === 2) {
        this.$refs.ruleForm2.validateField('email', isValid => {
          if (isValid) {
            canSend = false
          } else {
            console.log(isValid)
            canSend = true
          }
        })
      }
      if (canSend) {
        this.requestEmailCode()
      }
    },
    requestEmailCode () {
      let type = this.current === 2 ? 'new' : 'old'
      let data = this.current === 2 ? this.ruleForm2 : {
        email: this.params.email
      }
      this.getAuthCode()
      this.countStyle = { 'pointer-events': 'none' }
      return this.$api.sendEmailCode({
        data: data,
        type: type
      }).then(result => {
        let tip = ``
        if (!result.data.status) { // 验证码生成失败或者邮件发送失败
          tip = result.data.msg
        } else {
          let href = this.getEmailService(data.email)
          if (!href) {
            tip = this.$t('changeEmail.showTip1', [data.email])
          } else {
            tip = this.$t('changeEmail.showTip2', [data.email, href])
          }
          console.log(tip)
          this.phoneTip = tip
          this.emailTip = tip
        }
      }).catch(error => {
        console.log(error)
        return this.$message.error(error)
      })
    },
    logout () {
      const oAuth = new SecurityService()
      // clear LocalStorage call OAuth logout
      oAuth.signOut()
    },
    getCode () {
      if (this.activeName === 'email') {
        if (this.current === 1) this.sendEmailCode()
        if (this.current === 2) {
          this.clearIntervals()
          this.sendCodeTitle = this.$t('changeEmail.getCode')
          this.params.updateType === 'changeEmailAdd' ? this.sendEmailCode() : this.sendPhoneCode()
        }
      } else if (this.activeName === 'phone') {
        if (this.current === 1) this.sendPhoneCode()
        if (this.current === 2) {
          console.log(this.auth_timetimer)
          this.clearIntervals()
          this.sendCodeTitle = this.$t('changeEmail.getCode')
          this.params.updateType === 'changePhoneNum' ? this.sendPhoneCode() : this.sendEmailCode()
        }
      }
    },
    // 校验手机验证码
    verifyPhoneCode (formName) {
      this.loadingSubmit = true
      let phoneNumber

      this.current === 1 ? phoneNumber = this.params.changePhoneNum : phoneNumber = this.ruleForm2.newPhone

      let params = {
        phone_number: this.params.areaCode + phoneNumber,
        sms_code: this.ruleForm2.code,
        device_id: this.deviceId
      }
      commonRequest.checkPhone(params).then(res => {
        if (res.code === 200) {
          this.confirmCode = res.data.code
        }
      }).catch(error => {
        this.loadingSubmit = false
        console.log(error)
      })
      // let options = {
      //   areaCode: this.params.areaCode,
      //   vcode: this.ruleForm2.code
      // }
       // return new Promise((resolve, reject) => {
      //   this.$api.verifyCode(options, phoneNumber)
      //     .then(result => {
      //       console.log('promise resolve', result)
      //       if (result.status === 2) {
      //         return resolve(true)
      //       } else if (result.status !== 2) {
      //         return resolve(result)
      //       }
      //     }).catch(err => {
      //       return reject(err)
      //     })
      // })
    },
    // 更新手机号
    async updatePhoneNumRequest () {
      console.log('ok可以更新了')
      this.loadingSubmit = true
      // let params = {
      //   name: this.getClientProfile.userInfo.chineseName || '',
      //   phoneNumber: this.params.areaCode + this.ruleForm2.newPhone,
      //   oldNumber: this.params.areaCode + this.params.changePhoneNum,
      //   subject: this.$store.state.user.profile.sub,
      //   source: 'clientPortal'
      // }
      let params = {
        'code': this.confirmCode,
        'device_id': this.deviceId,
        'new_phone': this.params.areaCode + this.ruleForm2.newPhone,
        'old_phone': this.params.areaCode + this.params.changePhoneNum,
        'sms_code': this.ruleForm2.code,
        'submitSource': 'CP_WEB'
      }
      commonRequest.changeMobileNum(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: this.$t('setting.changePhone.success'),
            type: 'success'
          })
          localStorage.clear()
          setTimeout(() => {
            window.location.href = `${process.env.VUE_APP_AUTH}/login.html?client_id=account_center&client_secret=abcd&redirect_uri=${process.env.VUE_APP_CALLBACKURL}&state=sdfsfs&scope=basic&response_type=code&signup_uri=${process.env.VUE_APP_SIGNUP_URI}`
          }, 1200)
        } else {
          this.countdown = 0
          this.$message.error(res.msg)
        }
        this.loadingSubmit = false
      }).catch(error => {
        this.loadingSubmit = false
        console.log(error)
      })
      // this.$api.updatePhoneNum(params).then(result => {
      //   console.log('updatePhone', result)
      //   if (Number(result.code) === 200) {
      //     console.log(200)
      //     this.$message({
      //       message: this.$t('setting.changePhone.success'),
      //       type: 'success'
      //     })
      //     // 退出登录
      //     const oAuth = new SecurityService()
      //     oAuth.signOut()
      //   } else {
      //     this.countdown = 0
      //     console.log('!200')
      //     let status = result.code
      //     if (status === 4003) {
      //       this.$message.error(this.$t('setting.changePhone.registered'))
      //       return false
      //     } else if (status === 11013) {
      //       console.log('同步行情失败')
      //       this.$message.error(this.$t('setting.setPassword.resetPhoneFail'))
      //       return false
      //     }
      //   }
      // }).catch(error => {
      //   this.loadingSubmit = false
      //   console.log(error)
      //   this.countdown = 0
      //   if (error.code === 500) {
      //     this.$message.error(this.$t('setting.setPassword.resetPhoneFail'))
      //   } else {
      //     let msg = this.$t(`setting.changePhone[${error.code}]`) ? this.$t(`setting.changePhone[${error.code}]`) : this.$t('setting.changePhone.resetPhoneFail')
      //     this.$message.error(msg)
      //   }
      // })
    },
    // 校验邮件验证码
    verifyEmailCode (formName) {
      let data = this.current === 2 ? this.ruleForm2 : {
        email: this.params.email,
        code: this.ruleForm2.code
      }
      let type = this.current === 2 ? 'new' : 'old'
      this.loadingSubmit = true
      return new Promise((resolve, reject) => {
        this.$api.verifyEmailCode({ data: data, type: type }).then(result => {
          console.log('promise resolve', result)
          if (result.data.status === 2) {
            return resolve(true)
          } else if (result.data.status !== 2) {
            return resolve(result.data)
          }
        }).catch(err => {
          return reject(err)
        })
      })
    },
    // 更改邮件
    updateEmail (formName) {
      // TODO 调用邮件修改接口
      this.loadingSubmit = true
      let data = {
        email: this.ruleForm2.email,
        subject: this.$store.state.user.profile.sub,
        source: 'clientPortal'
      }
      this.$api.changeEmail(data).then(result => {
        if (result.code === 200) {
          this.openMessage('success', this.$t('setting.changeEmail.success'))
          this.logout()
        } else {
          this.$message.error(this.$t('setting.changeEmail.' + String(result.code)))
        }
      }).catch(error => {
        if (error.code === 500) {
          this.$message.error(this.$t('setting.changeEmail.changeEmailFail'))
        } else {
          this.$message.error(this.$t('setting.changeEmail.' + String(error.code)))
        }
        // this.openMessage('error', error.msg)
        console.log(error.msg)
      })
    },
    //
    checkSubmitData (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.current === 1) {
            this.activeName === 'phone' ? this.verifyPhoneCodeCb(1) : this.verifyEmailCodeCb(1)
          }
          if (this.current === 2) {
            this.params.updateType === 'changePhoneNum' ? this.verifyPhoneCodeCb(2) : this.verifyEmailCodeCb(2)
          }
        } else {
          this.$message.error('提交失败')
          console.log('error submit!!')
          return false
        }
      })
    },
    verifyPhoneCodeCb (current) {
      this.loadingSubmit = true
      let phoneNumber

      this.current === 1 ? phoneNumber = this.params.changePhoneNum : phoneNumber = this.ruleForm2.newPhone

      if (current === 1) {
        let params = {
          phone_number: this.params.areaCode + phoneNumber,
          sms_code: this.ruleForm2.code,
          device_id: this.deviceId
        }
        commonRequest.checkPhone(params).then(res => {
          if (res.code === 200) {
            this.confirmCode = res.data.code

            this.$refs['ruleForm2'].resetFields()
            this.current = 2
            this.clearIntervals()
            this.sendAuthCode = true
            this.switchEmail = true // 修改途中无法切换另外一种验证方式
            this.handTip(2)
          } else {
            this.$message.error(res.msg)
            return false
          }
          this.loadingSubmit = false
        })
      } else {
        this.sbmitForm('updatePhoneNumRequest')
      }
      // this.verifyPhoneCode()
      //   .then(pass => {
      //     if (pass === true) {
      //     // resolve true 验证码校验通过
      //       if (current === 1) {
      //         this.$refs['ruleForm2'].resetFields()
      //         this.current = 2
      //         this.clearIntervals()
      //         this.sendAuthCode = true
      //         this.loadingSubmit = false
      //         this.switchEmail = true // 修改途中无法切换另外一种验证方式
      //         this.handTip(2)
      //       } else {
      //         this.sbmitForm('updatePhoneNumRequest')
      //       }
      //     } else {
      //     // resolve result 验证码校验失败
      //       this.$message.error(pass.msg)
      //       this.loadingSubmit = false
      //       return false
      //     }
      //   }, failure => {
      //   // 服务异常
      //     console.log('reject', failure)
      //     this.loadingSubmit = false
      //     this.$message.error(failure.msg)
      //   })
    },
    verifyEmailCodeCb (current) {
      this.verifyEmailCode().then(pass => {
        console.log(pass)
        if (pass === true) {
          // resolve true 验证码校验通过
          if (current === 1) {
            this.$refs['ruleForm2'].resetFields()
            this.current = 2
            this.clearIntervals()
            this.switchPhone = true
            this.sendAuthCode = true
            this.loadingSubmit = false
            this.handTip(2)
          } else {
            this.sbmitForm('updateEmail')
          }
        } else {
          // resolve result 验证码校验失败
          this.loadingSubmit = false
          this.$message.error(pass.msg)
          return false
        }
      }, failure => {
        // 服务异常
        console.log('reject', failure)
        this.loadingSubmit = false
        this.$message.error(failure.msg)
      })
    },
    sbmitForm (type) {
      console.log('ok更新电话', type)
      this[type]()
    },

    clearIntervals () {
      if (this.auth_timetimer) {
        clearInterval(this.auth_timetimer)
      }
      this.sendAuthCode = true
      this.auth_timetimer = 0
      this.sendCodeTitle = this.$t('changeEmail.getCode')
    },
    cencel (formName) {
      this.current = 1
      this.handTip(1)
      this.$refs[formName].resetFields()
      this.$emit('closeFun', false)
      this.switchPhone = false
      this.switchEmail = false
    },
    // 切换更改方式
    selectVerifyType (tab, event) {
      console.log('tab,event', tab.name)
      // this.current = 1
      this.$refs['ruleForm2'].resetFields()
    }
  }
}

</script>

<style lang="scss">
.change-email {
  padding: 20px;
  height: auto;

  .title {
    text-align: center;
    font-size: 22px;
    color: #24282d;
  }

  .el-form {
    margin-bottom: 20px;
  }

  .el-input {
    height: 43px;
  }

  .el-button--sub {
    width: 100%;

    .el-button {
      width: 100%;
      color: #192b57;
      font-weight: bold;
      height: 58px;
      border-color: #ffe080;
      background-color: #fecd33;
    }
  }

  .el-button--cencel {
    width: 100%;

    .el-button {
      margin-top: 20px;
      width: 100%;
      color: #192b57;
      font-weight: bold;
      height: 58px;
      border-color: #192b57;
      background-color: #fff;
    }
  }

  .btn-auth-code {
    cursor: no-drop;
    height: 100%;
    line-height: 43px;
    color: #ccc;
    margin-right: 10px;
    font-size: 14px;
  }

  .btn-code {
    cursor: pointer;
    height: 100%;
    line-height: 43px;
    color: #fec000;
    margin-right: 10px;
    font-size: 14px;
  }

  .tip {
    text-align: center;
    font-size: 14px;
    color: #24282d;
    word-break: break-all;
    margin-top: 10px;
    margin-bottom: 30px;
  }
}
</style>
